module.exports = __webpack_public_path__ + "img/banner2_4New.49e8fa20.png";